import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import ArModal from '../../../components/Modal/ArModal';
import { deleteData, getAlert } from '../../../../utils/SamuiUtils';

const CustomerQueueEditor = ({
    isEditing,
    setIsEditing,
    setIsLoading,
    dlLineName,
    dlLineId,
    dlLineDetail,
    setDlLineDetail,
    searchARCodeOrName,
    setSearchARCodeOrName,
    itemsPerPage,
    setItemsPerPage,
    currentPage,
    setCurrentPage,
    filteredDetail,
    startIndex,
    endIndex,
    safeCurrentPage,
    Pagination,
    handlePageChange,
    arDataList,
    onRowSelected
}) => {
    const [editData, setEditData] = useState([]);
    const [originalData, setOriginalData] = useState([]);

    useEffect(() => {
        setEditData(dlLineDetail);
        setOriginalData(dlLineDetail);
    }, [dlLineDetail]);


    const moveQueueUp = (index) => {
        if (index > 0) {
            const newData = [...editData];
            [newData[index - 1], newData[index]] = [newData[index], newData[index - 1]];
            setEditData(updateQueueNumbers(newData));
        }
    };

    const moveQueueDown = (index) => {
        if (index < editData.length - 1) {
            const newData = [...editData];
            [newData[index], newData[index + 1]] = [newData[index + 1], newData[index]];
            setEditData(updateQueueNumbers(newData));
        }
    };
    const updateQueueNumbers = (data) => {
        return data.map((item, idx) => ({ ...item, DL_Queue: idx + 1 }));
    };

    const handleConfirmEdit = async () => {
        try {
            setIsLoading(true);

            await deleteData('DL_Line_D', `WHERE DL_Id = ${dlLineId}`);
            for (const data of editData) {
                await Axios.post(
                    `${process.env.REACT_APP_API_URL}/api/create-dl-line-d`,
                    {
                        dl_id: data.DL_Id,
                        dl_queue: data.DL_Queue,
                        dl_ar_id: data.DL_AR_Id,
                        comp_id: localStorage.getItem('company'),
                        dl_ar_code: data.DL_AR_Code,
                    },
                    {
                        headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                    }
                );
            }

            setIsLoading(false);
            getAlert('OK', 'แก้ไขข้อมูลสําเร็จ');
        } catch (error) {
            setIsLoading(false);
            getAlert('FAILED', error.message);
        } finally {
            setDlLineDetail(editData);
            setIsEditing(false);
            onRowSelected();
        }
    };
    const handleCancelEdit = () => {
        setEditData(originalData);
        setIsEditing(false);
        onRowSelected();
    };

    // SET AR
    const [showArModal, setShowArModal] = useState(false);
    const handleArShow = () => setShowArModal(true);
    const handleArClose = () => setShowArModal(false);
    const onRowSelectAr = (arSelected) => {
        try {
            const isCustomerExist = editData.some(item => item.AR_Id === arSelected.AR_Id);
            if (isCustomerExist) {
                getAlert("FAILED", "ลูกค้าคนนี้ถูกเลือกแล้ว");
                return;
            }
            setEditData((prevState) => [
                ...prevState,
                {
                    DL_Id: dlLineId,
                    DL_Queue: prevState.length + 1,
                    DL_AR_Id: arSelected.AR_Id,
                    Comp_Id: arSelected.Comp_Id,
                    DL_AR_Code: arSelected.AR_Code,
                    DL_LineName: dlLineName,
                    AR_Code: arSelected.AR_Code,
                    AR_Name: arSelected.AR_Name,
                    ARType_Name: arSelected.ARType_Name,
                },
            ]);
            handleArClose();
        } catch (error) {
            getAlert("FAILED", error);
        }
    };

    const tableData = isEditing ? editData.slice((safeCurrentPage - 1) * itemsPerPage, safeCurrentPage * itemsPerPage) : filteredDetail.slice((safeCurrentPage - 1) * itemsPerPage, safeCurrentPage * itemsPerPage);

    const handleDeleteCustomer = (dtId) => {
        const newData = editData.filter(item => item.DT_ID !== dtId);
        setEditData(newData);
    };

    return (
        <div className={`tab-pane fade show active`} role="tabpanel">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-6">
                                    <h5 className="card-title mt-3 me-4">รายชื่อลูกค้าตามสาย : {dlLineName}</h5>
                                </div>
                                <div className="col-4 d-flex justify-content-end">
                                    <input
                                        type="text"
                                        className="form-control form-control-md"
                                        placeholder="ค้นหาลูกค้า"
                                        value={searchARCodeOrName}
                                        onChange={(e) => {
                                            setSearchARCodeOrName(e.target.value);
                                            setCurrentPage(1);
                                        }}
                                        disabled={isEditing}
                                    />
                                </div>
                                <div className="col-2 d-flex justify-content-end">
                                    {dlLineId !== null && (
                                        <>
                                            {!isEditing && (
                                                <button
                                                    className="btn btn-lg shadow text-white d-flex align-items-center justify-content-center"
                                                    style={{
                                                        backgroundColor: "#EF6C00",
                                                        fontSize: "16px",
                                                        position: "relative",
                                                    }}
                                                    onClick={() => {
                                                        setIsEditing(true);
                                                        setEditData(dlLineDetail);
                                                        setOriginalData(dlLineDetail);
                                                    }}
                                                >
                                                    แก้ไขข้อมูล
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div
                            className="table-responsive"
                            style={{ maxHeight: "auto", overflowY: "auto" }}
                        >
                            <table
                                id="basic-datatables"
                                className="table table-striped table-hover"
                            >
                                <thead className="thead-dark">
                                    <tr>
                                        <th className="text-center" style={{ width: '2%' }}>#</th>
                                        <th className="text-center" style={{ width: '15%' }}>คิวลูกค้า</th>
                                        <th className="text-center" style={{ width: '10%' }}>รหัสลูกค้า</th>
                                        <th className="text-center" style={{ width: '42%' }}>ชื่อลูกค้า</th>
                                        <th className="text-center" style={{ width: '25%' }}>ประเภทลูกค้า</th>
                                        {isEditing && (
                                            <th className="text-center" style={{ width: '5%' }}>ลบ</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.length > 0 ? (
                                        tableData.map((detail, index) => (
                                            <tr key={detail.DT_ID}>
                                                <td className="text-center">{(safeCurrentPage - 1) * itemsPerPage + index + 1}</td>
                                                <td className="text-center">
                                                    {isEditing ? (
                                                        <>
                                                            <button
                                                                className="btn btn-sm btn-light me-2"
                                                                style={{
                                                                    color: '#EF6C00',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    fontSize: '18px',
                                                                    boxShadow: '0 1px 2px rgba(0,0,0,0.07)',
                                                                    border: 'none',
                                                                }}
                                                                onClick={() => moveQueueUp((safeCurrentPage - 1) * itemsPerPage + index)}
                                                                disabled={(safeCurrentPage - 1) * itemsPerPage + index === 0}
                                                            >
                                                                <i className="fa fa-arrow-up"></i>
                                                            </button>
                                                            <span style={{ margin: '0 10px', fontWeight: 500 }}>{detail.DL_Queue}</span>
                                                            <button
                                                                className="btn btn-sm btn-light"
                                                                style={{
                                                                    color: '#EF6C00',
                                                                    justifyContent: 'center',
                                                                    alignItems: 'center',
                                                                    fontSize: '18px',
                                                                    boxShadow: '0 1px 2px rgba(0,0,0,0.07)',
                                                                    border: 'none',
                                                                }}
                                                                onClick={() => moveQueueDown((safeCurrentPage - 1) * itemsPerPage + index)}
                                                                disabled={(safeCurrentPage - 1) * itemsPerPage + index === editData.length - 1}
                                                            >
                                                                <i className="fa fa-arrow-down"></i>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        detail.DL_Queue
                                                    )}
                                                </td>
                                                <td className="text-center">{detail.AR_Code}</td>
                                                <td className="text-left">{detail.AR_Name}</td>
                                                <td className="text-center">{detail.ARType_Name}</td>
                                                {isEditing && (
                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-sm btn-danger"
                                                            onClick={() => handleDeleteCustomer(detail.DT_ID)}
                                                        >
                                                            <i className="fa fa-trash"></i>
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={isEditing ? 7 : 6}>
                                                <center>
                                                    <h5>ไม่พบข้อมูล</h5>
                                                </center>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* Footer */}
                        <div className="d-flex justify-content-between align-items-center p-3">
                            {/* ตัวเลือกจำนวนแถว */}
                            <div>
                                <select
                                    value={itemsPerPage}
                                    onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                    className="form-select"
                                    disabled={isEditing}
                                >
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                            {/* การแสดงจำนวนข้อมูล */}
                            <div>
                                <span>
                                    แสดง {startIndex}-{endIndex} ของ{" "}
                                    {(isEditing ? editData.length : filteredDetail.length).toLocaleString()} รายการ
                                </span>
                            </div>
                            {/* Pagination */}
                            <Pagination
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                itemsPerPage={itemsPerPage}
                                dataMasterList={isEditing ? editData : filteredDetail}
                                handlePageChange={handlePageChange}
                            />
                        </div>
                        {isEditing && (
                            <div className="d-flex justify-content-between mt-3">
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-lg shadow text-white align-items-center justify-content-center"
                                        style={{
                                            backgroundColor: "blue",
                                            fontSize: "16px",
                                            marginRight: "10px"
                                        }}
                                        onClick={handleArShow}
                                    >
                                        เพิ่มลูกค้า
                                    </button>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-lg shadow text-white align-items-center justify-content-center"
                                        style={{
                                            backgroundColor: "green",
                                            fontSize: "16px",
                                            marginRight: "10px"
                                        }}
                                        onClick={handleConfirmEdit}
                                    >
                                        ยืนยัน
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-lg shadow text-white"
                                        style={{ backgroundColor: "red", fontSize: "16px" }}
                                        onClick={handleCancelEdit}
                                    >
                                        ยกเลิก
                                    </button>
                                </div>
                            </div>
                        )}
                        {showArModal && (
                            <ArModal
                                showArModal={showArModal}
                                handleArClose={handleArClose}
                                arDataList={arDataList}
                                onRowSelectAr={onRowSelectAr}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CustomerQueueEditor;
